<template>
  <div class="row mb-5 mx-n2 mx-sm-n5">
    <div
      class="category-bar p-0"
      :class="onClickParticipationTag ? 'active' : ''"
      @click="clickParticipationTag"
    >
      <div class="category py-1 px-2 py-sm-3 px-sm-5">
        <div class="row flex-grow-1 gy-4">
          <div v-if="shouldShowNumberOfInvited" class="col">
            <p class="text-muted fs-5 mb-1">
              {{ $t('widgetSurveyInfo.usersInvited') }}
            </p>
            <p class="fs-4 mb-0">{{ numberOfUsersInvited }}</p>
          </div>
          <div v-if="!containsOnlyFreeTextQuestions" class="col">
            <p
              v-if="
                !participationSettingsForGroup.hideResponded ||
                !participationSettingsForGroup.hidePercentage
              "
              class="text-muted fs-5 mb-1"
            >
              {{ $t('widgetSurveyInfo.usersResponded') }}
            </p>
            <p v-if="numberOfUsersThatHaveResponded" class="fs-4 mb-0">
              <span
                v-if="!participationSettingsForGroup.hideResponded"
                class="me-1"
              >
                {{ numberOfUsersThatHaveResponded }}
              </span>
              <span v-if="shouldShowPercentage">
                {{
                  `${
                    !participationSettingsForGroup.hideResponded ? '(' : ''
                  }${Math.round(participationPercentage * 100)} %${
                    !participationSettingsForGroup.hideResponded ? ')' : ''
                  }`
                }}
              </span>
            </p>
            <p v-else class="fs-4 mb-0">{{ $t('widgetSurveyInfo.noone') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyInfoParticipation',
  props: {
    id: {
      type: String,
      default: ''
    },
    participationSettingsForGroup: {
      type: Object,
      default: () => {}
    },
    participationTag: {
      type: Object,
      default: () => {}
    },
    onClickParticipationTag: {
      type: Function,
      default: () => {}
    },
    selectedAttributeSegment: {
      type: Object,
      default: () => {}
    },
    containsOnlyFreeTextQuestions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    numberOfUsersInvited() {
      return this.participationTag.numberOfResponses
    },
    numberOfUsersThatHaveResponded() {
      return this.participationTag.amount_10
    },
    participationPercentage() {
      return this.numberOfUsersThatHaveResponded / this.numberOfUsersInvited
    },
    shouldShowNumberOfInvited() {
      return (
        !this.participationSettingsForGroup.hideInvited &&
        this.selectedAttributeSegment.name === 'all'
      )
    },
    shouldShowPercentage() {
      return (
        !this.participationSettingsForGroup.hidePercentage &&
        this.selectedAttributeSegment.name === 'all'
      )
    }
  },
  methods: {
    clickParticipationTag() {
      if (this.onClickParticipationTag) {
        this.onClickParticipationTag()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.category-bar.active {
  cursor: pointer;
  > :hover {
    border-radius: 5px;
    background: var(--kt-list-group-action-active-bg);
  }

  .category {
    display: flex;
    flex: 0 0 50%;
  }
}
</style>
